import CartDelivery from './CartDelivery'

export default CartDelivery
